import { __rest } from "tslib";
import styled from '@emotion/styled';
import React, { forwardRef } from 'react';
import { theme } from '../../../theme';
import { useField } from 'formik';
import { StyledInputRoot, TextInputWrapper } from '../text-input';
export const StyledTextArea = styled.textarea `
	all: unset;
	resize: vertical;
	width: 100%;
	flex: inherit;
	padding: 0.625rem 0.75rem 0.625rem 1rem;
	position: relative;
	color: inherit;
	background-color: inherit;
`;
const StyledErrorMsg = styled.span `
	${theme.typography.IR90};
	color: ${theme.colors.NE100};
	padding: 0.5rem 0;
`;
// Internal TextArea component
export const InternalTextArea = forwardRef((props, ref) => {
    const { label = 1, runValidationWithoutTouch } = props;
    // Formik connector
    const [field, meta] = useField(props);
    const { touched, error } = meta;
    const shouldShowValidationError = runValidationWithoutTouch ? !!error : touched && !!error;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInputRoot, { touched: touched, error: error },
            React.createElement(StyledTextArea, Object.assign({ ref: ref, "data-testid": "input", "aria-label": props['aria-label'] || label }, field, meta, props))),
        shouldShowValidationError && React.createElement(StyledErrorMsg, null, error)));
});
export const TextArea = (_a) => {
    var { label } = _a, otherProps = __rest(_a, ["label"]);
    return (React.createElement(TextInputWrapper, Object.assign({ label: label }, otherProps),
        React.createElement(InternalTextArea, Object.assign({ label: label }, otherProps))));
};
//# sourceMappingURL=TextArea.js.map